(function(){
  function initHiTeaFlavourCarousel(wrap){
    if(!wrap) return;

    const grid = wrap.querySelector('.htx-grid');
    const cards = Array.from(wrap.querySelectorAll('.htx-card'));
    const prevBtn = wrap.querySelector('.htx-nav--prev');
    const nextBtn = wrap.querySelector('.htx-nav--next');

    if(!grid || !cards.length) return;

    const intervalTime = 3400;
    let current = 0;
    let autoTimer = null;
    let resumeTimer = null;

    function scrollCardInsideRow(index){
      if(!grid || !cards[index]) return;

      const card = cards[index];
      const cardLeft = card.offsetLeft;
      const cardWidth = card.offsetWidth;
      const gridWidth = grid.clientWidth;
      const targetLeft = cardLeft - ((gridWidth - cardWidth) / 2);

      grid.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: 'smooth'
      });
    }

    function activate(index, doScroll = true){
      cards.forEach((card, i) => {
        card.classList.toggle('is-active', i === index);
        if(i !== index) card.classList.remove('is-hovered');
      });

      current = index;

      if(doScroll){
        scrollCardInsideRow(index);
      }
    }

    function nextCard(){
      let next = current + 1;
      if(next >= cards.length) next = 0;
      activate(next, true);
    }

    function prevCard(){
      let prev = current - 1;
      if(prev < 0) prev = cards.length - 1;
      activate(prev, true);
    }

    function stopAuto(){
      if(autoTimer) clearInterval(autoTimer);
      if(resumeTimer) clearTimeout(resumeTimer);
    }

    function startAuto(){
      stopAuto();
      autoTimer = setInterval(nextCard, intervalTime);
    }

    cards.forEach((card, index) => {
      function enterCard(){
        stopAuto();
        activate(index, false);
        card.classList.add('is-hovered');
      }

      function leaveCard(){
        card.classList.remove('is-hovered');
        resumeTimer = setTimeout(() => {
          startAuto();
        }, 700);
      }

      card.addEventListener('mouseenter', enterCard);
      card.addEventListener('mouseleave', leaveCard);

      card.addEventListener('click', function(e){
        if(
          e.target.closest('.htx-buy') ||
          e.target.closest('.htx-card-link') ||
          e.target.closest('.htx-benefit')
        ){
          return;
        }

        stopAuto();
        activate(index, true);
        card.classList.add('is-hovered');

        resumeTimer = setTimeout(() => {
          card.classList.remove('is-hovered');
          startAuto();
        }, 1200);
      });
    });

    if(prevBtn){
      prevBtn.addEventListener('click', function(){
        stopAuto();
        prevCard();
        resumeTimer = setTimeout(startAuto, 1600);
      });
    }

    if(nextBtn){
      nextBtn.addEventListener('click', function(){
        stopAuto();
        nextCard();
        resumeTimer = setTimeout(startAuto, 1600);
      });
    }

    const buyBlocks = Array.from(wrap.querySelectorAll('.htx-buy'));

    buyBlocks.forEach((block) => {
      const minus = block.querySelector('.htx-qty-minus');
      const plus = block.querySelector('.htx-qty-plus');
      const value = block.querySelector('.htx-qty-value');
      const button = block.querySelector('.htx-add-cart');

      if(!minus || !plus || !value || !button) return;

      function getQty(){
        return Math.max(1, Math.min(10, Number(value.textContent || 1)));
      }

      function setQty(qty){
        value.textContent = String(Math.max(1, Math.min(10, qty)));
      }

      minus.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        setQty(getQty() - 1);
      });

      plus.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        setQty(getQty() + 1);
      });

      button.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();

        const variantId = block.getAttribute('data-variant-id');
        const qty = getQty();

        if(!variantId){
          button.classList.add('is-error');
          button.textContent = 'Variant Missing';
          return;
        }

        button.classList.remove('is-added', 'is-error');
        button.classList.add('is-loading');
        button.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: qty
          })
        })
        .then(function(response){
          if(!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function(){
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.textContent = 'Added to Cart';

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));

          setTimeout(function(){
            button.classList.remove('is-added');
            button.textContent = 'Shop This Flavour';
          }, 1500);
        })
        .catch(function(){
          button.classList.remove('is-loading');
          button.classList.add('is-error');
          button.textContent = 'Try Again';

          setTimeout(function(){
            button.classList.remove('is-error');
            button.textContent = 'Shop This Flavour';
          }, 1600);
        });
      });
    });

    window.addEventListener('resize', function(){
      activate(current, false);
    });

    activate(0, false);
    startAuto();
  }

  function bootHiTeaFlavourCarousels(){
    const wraps = Array.from(document.querySelectorAll('.htx-wrap'));

    wraps.forEach((wrap) => {
      if(wrap.dataset.htxReady === 'true') return;

      wrap.dataset.htxReady = 'true';
      initHiTeaFlavourCarousel(wrap);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootHiTeaFlavourCarousels);
  }else{
    bootHiTeaFlavourCarousels();
  }

  document.addEventListener('shopify:section:load', bootHiTeaFlavourCarousels);
})();